import { FlashingCellStyle } from '../../../View/FlashingCell/FlashingCellStyle';
export const getFlashingCellStyleViewItems = () => {
    return {
        name: 'Flash Styles',
        label: 'Change Style',
        view: FlashingCellStyle,
    };
};
